/* eslint global-require: 0 */
/* eslint react/no-danger: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export const LANGS = ['ru', 'en'];

export const translate = (text, lang) => {
  let value;

  if (text) {
    value =
      text === Object(text) ? (text[lang] ? text[lang] : text['ru']) : text;

    if (value === undefined && text['en']) value = text['en'];
  }

  if (value === undefined) {
    value = 'localization error';
  }

  return value;
};

const TranslatedText = ({ lang, className, text, dispatch, ...props }) => {
  const value = translate(text, lang);
  return (
    <span
      dangerouslySetInnerHTML={{ __html: value }}
      className={className}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  lang: state.i18n.locale,
});

TranslatedText.propTypes = {
  id: PropTypes.string,
  lang: PropTypes.string,
};

TranslatedText.defaultProps = {
  id: 'undefined',
  lang: 'undefined',
};

export default connect(mapStateToProps)(TranslatedText);
